var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1650FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17241_21226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16L16 8.5L8.5 16H10.1667V21.8333C10.1667 22.2754 10.3423 22.6993 10.6548 23.0118C10.9674 23.3244 11.3913 23.5 11.8333 23.5H15.75",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.4999V18.4999C13.5 18.0579 13.6756 17.634 13.9882 17.3214C14.3007 17.0088 14.7246 16.8333 15.1667 16.8333H16.8333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21C18.5 21.663 18.7634 22.2989 19.2322 22.7678C19.7011 23.2366 20.337 23.5 21 23.5C21.663 23.5 22.2989 23.2366 22.7678 22.7678C23.2366 22.2989 23.5 21.663 23.5 21C23.5 20.337 23.2366 19.7011 22.7678 19.2322C22.2989 18.7634 21.663 18.5 21 18.5C20.337 18.5 19.7011 18.7634 19.2322 19.2322C18.7634 19.7011 18.5 20.337 18.5 21Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8359 22.8333L24.3359 24.3333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17241_21226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchProperty);
export default __webpack_public_path__ + "static/media/searchProperty.5bfb4e6cdccb8726599985c0d4c32a96.svg";
export { ForwardRef as ReactComponent };